<template>
  <div class="indexs" :style="'background: url('+ $store.state.config.fileUrl +'icon/pc/bg_index.gif.gif);background-size: 100% 100%;'">
    <div class="index_bg">
      <div class="index_title">
        <p>三门峡市校园安全双重预防(雪亮工程)平台</p>
        <img
          style="margin-top:-54px; opacity: 0.7;"
          src="@/assets/img/schoolIndex/index_titleButtom.png"
          alt=""
        />
      </div>
      <div class="index_imgContent">
        <div
          style="margin-top: 0.5%"
          @click="sel('/eduSecuritySituation_1', 1)"
        >
          <img src="@/assets/img/sanMen/1.png" alt="" />
        </div>
        <div
          style="margin-top: 2.7%"
          @click="sel('/eduRiskStatistics', 2)"
        >
          <img src="@/assets/img/sanMen/2.png" alt="" />
        </div>
        <div
          style="margin-top: 3.4%"
          @click="sel('/eduHiddenDangerStatistics', 3)"
        >
          <img src="@/assets/img/sanMen/3.png" alt="" />
        </div>
        <div
          style="margin-top: 3.4%"
          @click="sel('/eduFilesStatistics', 4)"
        >
          <img src="@/assets/img/sanMen/4.png" alt="" />
        </div>
        <div
          style="margin-top: 2.7%"
          @click="sel('/eduSafetyCenter', 5)"
        >
          <img src="@/assets/img/sanMen/5.png" alt="" />
        </div>
        <div
          style="margin-top: 0.3%"
          @click="sel('/eduSafetyMap', 6)"
        >
          <img src="@/assets/img/sanMen/6.png" alt="" />
        </div>
      </div>
        <!-- <h2 class="school-big-data-box" @click="pushBigData">
          <span v-for="(item, index) in title" :key="index">{{ item }}</span>
        </h2> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "indexs",
  data() {
    return {
      // schoolId: parseInt(this.$store.state.schoolId),
      // title: "安全大数据平台"
    };
  },
  components: {},
  methods: {
    sel(path,num) {
      this.$Common.pageJump(path, "", 0);
      this.$store.commit("setEduBidDataSelect", num);
      // if (a) {
      //   this.$store.commit("updatePathIndex", a);
      // }
      // if (path == "/basics_info") {
      //   sessionStorage.setItem("schoolBigSelect", 0);
      // }
      // this.$Common.pageJump(path, a, num);
      // this.$store.commit("setSelect", b);
    },
    // 获取学校信息
    // async getSchoolInfo() {
    //   var requestData = {
    //     schoolId: this.schoolId
    //   };
    //   let res = await this.$Http.getSchoolInfo(requestData, true);
    //   if (res.code == 200) {
    //     // console.log(res.data)
    //     this.$store.commit("updateSchoolInfo", res.data);
    //   } else if (res.code == 101) {
    //   } else {
    //     this.$message({
    //       message: res.msg,
    //       type: "error"
    //     });
    //   }
    // },
    // pushBigData() {
    //   let routeUrl = this.$router.resolve({
    //     path: "/safeposture_school"
    //   });
    //   window.open(routeUrl.href, "_blank");
    // }
  },
  mounted() {
    // this.getSchoolInfo();
  }
};
</script>
<style lang="scss" scoped>
.indexs {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: url("https://school.zzsasoft.com/uploads/icon/pc/bg_index.gif.gif")
    center center / cover no-repeat;
  background-size: cover;
}
.index_bg {
  height: 80%;
  width: 70%;
  z-index: 10;
  position: fixed;
  top: 10%;
  left: 15.4%;
  background: url("~@/assets/img/schoolIndex/index_content2.png") no-repeat;
  background-size: 100% 100%;
}
.index_title {
  letter-spacing: 5px;
  margin-top: 10%;
  text-align: center;
  width: 100%;
  color: white;
  font-size: 2.5rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.index_imgContent {
  margin-top: 2%;
  margin-left: 10%;
}
.index_imgContent {
  div {
    width: 12%;
    float: left;
    margin-left: 2.5%;
    background-size: cover;
    cursor: pointer;
    transition: all 0.6s;
    &:hover {
      transform: scale(1.1);
    }
  }
  img {
    &:nth-child(1) {
      width: 100%;
      cursor: pointer;
      transition: all 0.6s;
    }
  }
  p {
    margin: 0;
    color: rgb(234, 241, 251);
    text-align: center;
    font-size: 1rem;
    height: 20px;
    overflow: hidden;
    line-height: 25px;
    letter-spacing: 1px;
  }
}

h2 span {
  float: left;
  position: relative;
  font-size: 22px;
    color: rgb(170, 222, 252);
}

h2 span:nth-child(1) {
  -webkit-animation: jump 1.2s linear 0s infinite alternate;
}

h2 span:nth-child(2) {
  -webkit-animation: jump 1.2s linear 0.1s infinite alternate;
}

h2 span:nth-child(3) {
  -webkit-animation: jump 1.2s linear 0.2s infinite alternate;
}

h2 span:nth-child(4) {
  -webkit-animation: jump 1.2s linear 0.3s infinite alternate;
}

h2 span:nth-child(5) {
  -webkit-animation: jump 1.2s linear 0.4s infinite alternate;
}

h2 span:nth-child(6) {
  -webkit-animation: jump 1.2s linear 0.5s infinite alternate;
}

h2 span:nth-child(7) {
  -webkit-animation: jump 1.2s linear 0.6s infinite alternate;
}

h2 span:nth-child(8) {
  -webkit-animation: jump 1.2s linear 0.7s infinite alternate;
}

h2 span:nth-child(9) {
  -webkit-animation: jump 1.2s linear 0.8s infinite alternate;
}

h2 span:nth-child(10) {
  -webkit-animation: jump 1.2s linear 0.9s infinite alternate;
}

h2 span:nth-child(11) {
  -webkit-animation: jump 1.2s linear 1.0s infinite alternate;
}

h2 span:nth-child(12) {
  -webkit-animation: jump 1.2s linear 1.1s infinite alternate;
}

@-webkit-keyframes jump {
  0% {
    top: 0px;
  }
  50% {
    top: -4px;
  }
  100% {
    top: 4px;
  }
}
.school-big-data-box {
  position: fixed;
  top: 73%;
  left: 45.5%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
